import React, { FunctionComponent } from 'react';
import type { RecruitmentShowContentFollowSliderMiddleProps } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowContentFollowSliderMiddleProps & {
  applications: Recruitment[];
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  isStopped,
  noimage,
  occupationName,
  occupationUrl,
  dataCategory,
  dataValue,
  applications,
}) => {
  if (!applications || applications.length === 0) return null;
  return (
    <div className={`recruitment__show__content recruitment__show__company ${isStopped ? 'is-stopped' : ''}`} id="occupation-recruitments-section">
      <h3 className="mainTitle">
        {occupationName}の求人
        <a className="link gtm-button-view-count" href={`/${occupationUrl}`} data-event-name='button on screen' data-event='click' data-category={dataCategory} data-value={dataValue?.moreRelatedSoRecruitments}>もっと見る</a>
      </h3>
      <div className='recruitment__show__applications__slider js-recruitment-show-content-follow-middle'>
        {applications.map((application) => (
          <a
            key={application.id}
            href={`/recruitments/${application.id}`}
            data-event-name='recruitments on screen'
            data-event='click'
            data-category={dataCategory}
            data-value={dataValue?.relatedSoRecruitments}
            data-recruitmentid={application.id}
            data-companyid={application.companyId}
            target="_blank"
            className="box gtm-recruitment-view-count"
          >
            {application.image.url ? (
              <img src={application.image.url} alt={`${application.title}の画像`} />
            ) : (
              <img src={noimage} alt={`${application.title}の画像`} />
            )}
            <p className="title">
              <span className="occupation">{application.title}</span>
              <span className="prefecture">{application.prefecture}</span>
            </p>
            <p className="body">{application.body}</p>
            <div className="bottomBox">
              {application.icon ? (
                <img src={application.icon} alt={`${application.title}の画像`} className="icon" />
              ) : (
                <img src={noimage} alt={`${application.title}の画像`} className="icon" />
              )}
              <p className="companyName">{application.companyName}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
